import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "stage-container"
};
const _hoisted_2 = {
  class: "content-view"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = {
  class: "form-tag"
};
const _hoisted_5 = {
  style: {
    "width": "360px"
  }
};
const _hoisted_6 = {
  style: {
    "flex": "1",
    "margin-left": "24px"
  }
};
const _hoisted_7 = {
  class: "resumes-grid-view"
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 0,
  class: "applications-container"
};
const _hoisted_10 = {
  key: 1,
  class: "applications-container"
};
const _hoisted_11 = {
  key: 2,
  class: "applications-container"
};
const _hoisted_12 = {
  key: 3,
  class: "applications-container"
};
const _hoisted_13 = {
  class: "empty-data-tips"
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  key: 0,
  class: "applications-container"
};
const _hoisted_16 = {
  key: 1,
  class: "applications-container"
};
import { onMounted, ref, computed, watch } from 'vue';
import { ElMessage, ElRow, ElSwitch } from 'element-plus';
import { getPerformanceDesc } from "@/tools/utils";
import { request } from '@/manager/net_manager';
import { socketService } from "@/manager/socket_manager";
import store from '@/store';
import _ from "lodash";
import ApplicationReviewCard from '@/components/Stage/ApplicationReviewCard.vue';
import ApplicationRoleCard from '@/components/Stage/ApplicationRoleCard.vue';
import PocketPropsCard from "@/components/Props/PocketPropsCard.vue";
import MaskerLayer from "@/components/Basic/MaskerLayer.vue";
import StagePropsReviewCard from "@/components/Stage/StagePropsReviewCard.vue";
import DramaListCard from "@/components/Drama/DramaListCard.vue";
import ActorResumeCard from "@/components/Stage/ActorResumeCard.vue";
import { pageStyle } from "@/theme/sliderStyle"; // refs

export default {
  __name: 'BackstagePage',

  setup(__props) {
    const actorApplications = ref(null);
    const audienceApplications = ref(null);
    const roles = ref([]);
    const propsReviewArray = ref([]);
    const roleProp = ref(null);
    const reviewMode = ref(false);
    const settlementForm = ref({}); // computed

    const stage = computed(() => store.state.stage ?? null);
    const joinable = computed(() => store.state.stage?.joinable ?? false);
    const performance = computed(() => store.state.stage?.performance ?? null);
    const actor = computed(() => {
      if (!performance.value) return [];
      return performance.value?.cast ?? [];
    }); // functions

    const getApplicationsData = () => {
      if (!stage.value) return;
      let parameters = {};
      parameters['stage_id'] = stage.value.stage_id;
      request('stage/applications/list/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          actorApplications.value = response.data.actor;
          audienceApplications.value = response.data.audience;
          roles.value = roles.value.filter(role_id => {
            let buffer = actorApplications.value.map(application => {
              return application.role.id.toString() === role_id.toString();
            });

            if (buffer.length === 0) {
              buffer = audienceApplications.value.map(application => {
                return application.role.id.toString() === role_id.toString();
              });
            }

            return buffer.length !== 0;
          });
        } else {
          ElMessage.error(response.msg);
        }
      });
    };

    const getPropsReviewData = () => {
      if (!stage.value) return;
      let parameters = {};
      parameters['stage_id'] = stage.value.stage_id;
      request('stage/props_review/list/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          propsReviewArray.value = response.data; // roles.value = roles.value.filter(role_id => {
          //   let buffer = actorApplications.value.map(application => {
          //     return application.role.id.toString() === role_id.toString()
          //   })
          //   if (buffer.length === 0) {
          //     buffer = audienceApplications.value.map(application => {
          //       return application.role.id.toString() === role_id.toString()
          //     })
          //   }
          //   return buffer.length !== 0
          // })
        } else {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
        }
      });
    };

    const saveStageSnapshot = _.debounce((mute = true) => {
      if (!stage.value) return;
      request('stage/snapshot/save/', {
        'stage_id': stage.value.stage_id
      }, 'POST').then(response => {
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        if (!mute) {
          ElMessage.success({
            message: '数据缓存成功',
            duration: 1500
          });
        }
      });
    }, 300);

    const updateApplication = (applicationId, status) => {
      let parameters = {
        'application_id': applicationId,
        'status': status
      };
      request('stage/applications/update/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          getApplicationsData();
          saveStageSnapshot();
          socketService.send({
            'type': 'applications_update',
            'text': ''
          });
        } else {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
        }
      });
    };

    const updateRoles = roleId => {
      // console.log('updateRoles', roleId)
      if (roles.value.includes(roleId)) {
        let index = roles.value.indexOf(roleId);
        if (index !== -1) roles.value.splice(index, 1);
      } else {
        roles.value.push(roleId);
      }
    };

    const onModeChange = _.debounce(() => {
      if (reviewMode.value) {
        getPropsReviewData();
      } else {
        getApplicationsData();
      }
    }, 300);

    const showPropDetail = item => {
      roleProp.value = item;
    };

    const closePropDetail = () => {
      roleProp.value = null;
    };

    const updateReview = (reviewId, status) => {
      let parameters = {
        'review_id': reviewId,
        'status': status
      };
      request('stage/props_review/update/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          getPropsReviewData();
          saveStageSnapshot();
        } else {
          ElMessage.error(response.msg);
        }
      });
    };

    const joinableChanged = () => {
      if (!stage.value) return;
      let parameters = {
        'updates': {
          'stage_id': stage.value.stage_id,
          'joinable': !joinable.value
        }
      };
      request('stage/update/', parameters, 'POST').then(response => {
        if (response.code === 0) {
          ElMessage.success({
            message: '招募状态变更完成',
            duration: 1500
          });
          let stageData = structuredClone(stage.value);
          stageData['joinable'] = !joinable.value;
          store.commit('update_stage', stageData);
        }
      });
    };

    const updatePerformanceStatus = status => {
      if (!stage.value || !stage.value.performance) return;
      let parameters = {
        'updates': {
          'stage_id': stage.value.stage_id,
          'status': status
        }
      };
      request('stage/update/', parameters, 'POST').then(response => {
        if (response.code === 0) {
          ElMessage.success({
            message: '演出状态变更完成',
            duration: 1500
          });
          getPerformanceData();
          socketService.send({
            'type': 'performance_status_update',
            'text': getPerformanceDesc(status)
          });
        } else {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
        }
      });
    };

    const getPerformanceData = () => {
      if (!stage.value || !stage.value.performance) return;
      request('stage/performance/get/', {
        'id': stage.value.performance.id
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          let stageData = structuredClone(stage.value);
          stageData['performance'] = response.data;
          store.commit('update_stage', stageData);
        }
      });
    };

    const submitSettle = () => {
      const parameters = {
        'id': stage.value.performance.id,
        'summary': settlementForm.value.summary,
        'duration': settlementForm.value.duration,
        'completeness': settlementForm.value.completeness,
        'solving_rate': settlementForm.value.solving_rate
      };
      request('stage/performance/update/', parameters, 'POST').then(response => {
        if (response.code === 0) {
          ElMessage.success({
            message: '演出结算完成',
            duration: 1500
          });
          let stageData = structuredClone(stage.value);
          stageData['performance']['summary'] = settlementForm.value.summary;
          stageData['performance']['duration'] = settlementForm.value.duration;
          stageData['performance']['completeness'] = settlementForm.value.completeness;
          stageData['performance']['solving_rate'] = settlementForm.value.solving_rate;
          store.commit('update_stage', stageData);
        } else {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
        }
      });
    };

    const updateResume = updates => {
      updates['updates']['performance_id'] = stage.value.performance.id;
      request('stage/resume/update/', updates, 'POST').then(response => {
        if (response.code === 0) {
          ElMessage.success({
            message: '角色履历结算完成',
            duration: 1500
          });
          getPerformanceData();
        } else {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
        }
      });
    }; // lifecycle


    onMounted(() => {
      // stageId.value = router.currentRoute.value.params.stageId
      getApplicationsData();
    }); // watcher

    watch(() => performance.value, newValue => {
      if (newValue && newValue.status === 2) {
        settlementForm.value.summary = newValue.summary;
        settlementForm.value.duration = newValue.duration;
        settlementForm.value.completeness = newValue.completeness;
        settlementForm.value.solving_rate = newValue.solving_rate;
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_col = _resolveComponent("el-col");

      return _openBlock(), _createElementBlock("div", {
        id: "page-container",
        style: _normalizeStyle(_unref(pageStyle))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("text", _hoisted_4, _toDisplayString(`${stage.value.stage_name} / 后台管理`), 1), [0, 1].includes(performance.value.status) ? (_openBlock(), _createBlock(_unref(ElSwitch), {
        key: 0,
        modelValue: joinable.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => joinable.value = $event),
        "active-text": joinable.value ? '招募中' : '',
        "inactive-text": joinable.value ? '' : '停止招募',
        "inline-prompt": "",
        onChange: joinableChanged
      }, null, 8, ["modelValue", "active-text", "inactive-text"])) : _createCommentVNode("", true), performance.value.status === 0 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        onClick: _cache[1] || (_cache[1] = $event => updatePerformanceStatus(1))
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" 开始演出 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true), performance.value.status === 1 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        onClick: _cache[2] || (_cache[2] = $event => _unref(saveStageSnapshot)(false))
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" 保存演出数据 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true), performance.value.status === 1 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 3,
        onClick: _cache[3] || (_cache[3] = $event => updatePerformanceStatus(2))
      }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode(" 关闭舞台 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true), [0, 1].includes(performance.value.status) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 4,
        style: {
          "justify-content": "flex-end",
          "flex": "1"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElSwitch), {
          modelValue: reviewMode.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => reviewMode.value = $event),
          "active-text": reviewMode.value ? '道具审查' : '',
          "inactive-text": reviewMode.value ? '' : '角色申请',
          "inline-prompt": "",
          onChange: _unref(onModeChange)
        }, null, 8, ["modelValue", "active-text", "inactive-text", "onChange"])]),
        _: 1
      })) : _createCommentVNode("", true)]), _cache[16] || (_cache[16] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), performance.value.status === 2 ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        class: "settle-container"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), {
          class: "performance-container"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(DramaListCard, {
            data: stage.value.performance.drama
          }, null, 8, ["data"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_unref(ElRow), {
            style: {
              "width": "100%",
              "align-items": "center",
              "gap": "32px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "完成度",
              "label-position": "left"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: settlementForm.value.completeness,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => settlementForm.value.completeness = $event),
                min: 1,
                max: 100,
                class: "main-input-number"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "破解度",
              "label-position": "left"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: settlementForm.value.solving_rate,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => settlementForm.value.solving_rate = $event),
                min: 1,
                max: 100,
                class: "main-input-number"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "演出时长",
              "label-position": "left"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: settlementForm.value.duration,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => settlementForm.value.duration = $event),
                min: 1,
                max: 100,
                class: "main-input-number duration"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "演出简述",
            "label-position": "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: settlementForm.value.summary,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => settlementForm.value.summary = $event),
              type: "textarea",
              clearable: "",
              "show-word-limit": "",
              round: "",
              placeholder: "一段简单概括...",
              maxlength: "256"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            style: {
              "width": "100%",
              "justify-content": "flex-end"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: submitSettle
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" 提交演出结算数据 ", -1)]))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        }), _cache[13] || (_cache[13] = _createElementVNode("div", {
          class: "divider"
        }, null, -1)), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actor.value, (item, index) => {
          return _openBlock(), _createBlock(ActorResumeCard, {
            key: index,
            data: item,
            duration: performance.value.duration,
            onSubmitResume: updateResume
          }, null, 8, ["data", "duration"]);
        }), 128))])]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_8, [!reviewMode.value ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 7
        }, {
          default: _withCtx(() => [actorApplications.value && actorApplications.value.length !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actorApplications.value, (item, index) => {
            return _openBlock(), _createBlock(ApplicationReviewCard, {
              key: index,
              data: item,
              isSelected: roles.value.includes(item.role.id),
              "performance-status": performance.value.status,
              onAddRole: updateRoles,
              onUpdate: updateApplication
            }, null, 8, ["data", "isSelected", "performance-status"]);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[14] || (_cache[14] = [_createElementVNode("text", {
            class: "empty-data-tips"
          }, " 目前尚无演职员申请 ", -1)]))])), audienceApplications.value && audienceApplications.value.length !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audienceApplications.value, (item, index) => {
            return _openBlock(), _createBlock(ApplicationReviewCard, {
              key: index,
              data: item,
              isSelected: roles.value.includes(item.role.id),
              "performance-status": performance.value.status,
              onAddRole: updateRoles,
              onUpdate: updateApplication
            }, null, 8, ["data", "isSelected", "performance-status"]);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("text", _hoisted_13, _toDisplayString(stage.value.audience_capacity !== 0 ? '目前尚无观众席申请' : '舞台未开放观众席'), 1)]))]),
          _: 1
        }), _createVNode(_component_el_col, {
          offset: 1,
          span: 16
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (item, index) => {
            return _openBlock(), _createBlock(ApplicationRoleCard, {
              key: index,
              "role-id": item,
              onCloseRole: updateRoles
            }, null, 8, ["role-id"]);
          }), 128))]),
          _: 1
        })]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_14, [propsReviewArray.value !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(propsReviewArray.value, (item, index) => {
        return _openBlock(), _createBlock(StagePropsReviewCard, {
          key: index,
          data: item,
          onSelectedProp: showPropDetail,
          onUpdate: updateReview
        }, null, 8, ["data"]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[15] || (_cache[15] = [_createElementVNode("text", {
        class: "empty-data-tips"
      }, " 尚无角色需要道具审查 ", -1)]))]))]))]))])]), roleProp.value !== null ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 0,
        onClose: closePropDetail
      }, {
        default: _withCtx(() => [_createVNode(PocketPropsCard, {
          "prop-id": roleProp.value.id,
          "operation-enable": false
        }, null, 8, ["prop-id"])]),
        _: 1
      })) : _createCommentVNode("", true)], 4);
    };
  }

};